(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wzlt-buy-now-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buy-now-button')) {
    class BuyNowButton extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('[data-variant-input]');
        this.quantityInput = this.querySelector('[data-quantity-input]');
        this.submitButton = this.querySelector('[data-buy-now-submit]');
        this.textEl = this.querySelector('[data-buy-now-text]');
        this.checkoutUrl = this.dataset.checkoutUrl || '/checkout';
        this.cartAddJsUrl = this.dataset.cartAddJsUrl || '/cart/add.js';
        this.cartClearUrl = this.dataset.cartClearUrl || '/cart/clear.js';
        this.clearCart = this.dataset.clearCart === 'true';
        this.soldOutLabel = this.dataset.soldOutLabel || 'Agotado';
        this.loadingLabel = this.dataset.loadingLabel || 'Procesando...';
        this.defaultLabel = this.textEl ? this.textEl.textContent.trim() : '';
        this.sectionId = this.dataset.sectionId;

        if (!this.form || !this.variantInput || !this.submitButton) return;

        if (this.sectionId) {
          this._section = document.getElementById('shopify-section-' + this.sectionId);
        }

        this._onVariantChange = this._onVariantChange.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
        this._onMainVariantChange = this._onMainVariantChange.bind(this);
        this._onQuantityChange = this._onQuantityChange.bind(this);
        this._stopPropagation = this._stopPropagation.bind(this);

        document.addEventListener('variant:change', this._onVariantChange);
        document.addEventListener('variant:changed', this._onVariantChange);

        this.form.addEventListener('submit', this._onSubmit, true);
        this.submitButton.addEventListener('click', this._stopPropagation, true);
        this._bindMainProductForm();
        this._syncFromUrl();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:change', this._onVariantChange);
        document.removeEventListener('variant:changed', this._onVariantChange);
        this._unbindMainProductForm();
      }

      _stopPropagation(event) {
        event.stopPropagation();
      }

      _bindMainProductForm() {
        var scope = this._section || document;
        var mainForm = scope.querySelector(
          'form.shopify-product-form, product-form form, [data-product-form] form'
        );

        if (!mainForm || mainForm === this.form) return;

        this._mainForm = mainForm;
        this._mainVariantInput = mainForm.querySelector('input[name="id"]');
        this._mainQuantityInput = mainForm.querySelector('input[name="quantity"]');

        if (this._mainVariantInput) {
          this._mainVariantInput.addEventListener('change', this._onMainVariantChange);
        }

        if (this._mainQuantityInput) {
          this._mainQuantityInput.addEventListener('change', this._onQuantityChange);
          this._mainQuantityInput.addEventListener('input', this._onQuantityChange);
        }
      }

      _unbindMainProductForm() {
        if (this._mainVariantInput) {
          this._mainVariantInput.removeEventListener('change', this._onMainVariantChange);
        }
        if (this._mainQuantityInput) {
          this._mainQuantityInput.removeEventListener('change', this._onQuantityChange);
          this._mainQuantityInput.removeEventListener('input', this._onQuantityChange);
        }
      }

      _syncFromUrl() {
        var params = new URLSearchParams(window.location.search);
        var variantId = params.get('variant');
        if (variantId) this._setVariant(variantId, null);
      }

      _onMainVariantChange(event) {
        this._setVariant(event.target.value, null);
      }

      _onQuantityChange(event) {
        if (!this.quantityInput) return;
        var quantity = parseInt(event.target.value, 10);
        this.quantityInput.value = quantity > 0 ? String(quantity) : '1';
      }

      _onVariantChange(event) {
        if (!event.detail) return;
        var variant = event.detail.variant || event.detail;
        if (!variant || !variant.id) return;
        this._setVariant(String(variant.id), variant.available);
      }

      _setVariant(variantId, isAvailable) {
        if (!variantId || !this.variantInput) return;

        this.variantInput.value = variantId;
        this.variantInput.disabled = false;

        if (typeof isAvailable === 'boolean') {
          this._setAvailability(isAvailable);
        }
      }

      _setAvailability(isAvailable) {
        if (!this.submitButton || !this.textEl) return;

        this.submitButton.disabled = !isAvailable;
        this.submitButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
        this.textEl.textContent = isAvailable ? this.defaultLabel : this.soldOutLabel;
      }

      _setLoading(isLoading) {
        if (!this.submitButton || !this.textEl) return;
        this.submitButton.disabled = isLoading;
        this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        this.textEl.textContent = isLoading ? this.loadingLabel : this.defaultLabel;
      }

      _goToCheckout() {
        window.location.href = this.checkoutUrl;
      }

      async _onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        var variantId = this.variantInput.value;
        var quantity = parseInt(this.quantityInput.value, 10) || 1;

        if (!variantId || this.submitButton.disabled) return;

        this._setLoading(true);

        try {
          if (this.clearCart) {
            await fetch(this.cartClearUrl, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin'
            });
          }

          var response = await fetch(this.cartAddJsUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: quantity }]
            })
          });

          var data = await response.json();

          if (!response.ok) {
            throw new Error(data.description || data.message || 'No se pudo agregar el producto.');
          }

          this._goToCheckout();
        } catch (error) {
          this._setLoading(false);
          if (this.textEl) {
            this.textEl.textContent = error.message || 'Error al procesar la compra.';
          }
        }
      }
    }

    customElements.define('buy-now-button', BuyNowButton);
  }
  } catch(e) { console.error(e); }
})();

})();
